import { type Dispatch, useState } from "react";

// eslint-disable-next-line no-restricted-syntax
export enum ModalStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

export interface UseModalState {
  modalStatus: ModalStatus;
  setModalStatus: Dispatch<ModalStatus>;
  modalIsClosed: boolean;
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

/**
 * @deprecated Use the useStableModalState hook instead. This hook returns a new object and new
 * openModal/closeModal references on every render, which breaks memoization and re-triggers
 * effects when its return value is used as a dependency.
 */
export function useModalState(initialModalStatus = ModalStatus.CLOSED): UseModalState {
  const [modalStatus, setModalStatus] = useState(initialModalStatus);
  function openModal() {
    setModalStatus(ModalStatus.OPEN);
  }

  function closeModal() {
    setModalStatus(ModalStatus.CLOSED);
  }

  return {
    modalStatus,
    setModalStatus,
    modalIsClosed: modalStatus === ModalStatus.CLOSED,
    modalIsOpen: modalStatus === ModalStatus.OPEN,
    openModal,
    closeModal,
  };
}
